/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Private events are by invitation; anyone eligible may join a public event.
 * @export
 */
export const EventAccess = {
    Private: 'private',
    Public: 'public'
} as const;
export type EventAccess = typeof EventAccess[keyof typeof EventAccess];


export function instanceOfEventAccess(value: any): boolean {
    for (const key in EventAccess) {
        if (Object.prototype.hasOwnProperty.call(EventAccess, key)) {
            if (EventAccess[key as keyof typeof EventAccess] === value) {
                return true;
            }
        }
    }
    return false;
}

export function EventAccessFromJSON(json: any): EventAccess {
    return EventAccessFromJSONTyped(json, false);
}

export function EventAccessFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventAccess {
    return json as EventAccess;
}

export function EventAccessToJSON(value?: EventAccess | null): any {
    return value as any;
}

export function EventAccessToJSONTyped(value: any, ignoreDiscriminator: boolean): EventAccess {
    return value as EventAccess;
}

